module.exports = __webpack_public_path__ + "img/banner.7210e7c5.svg";